var exports = {
  "Bq": "GeneralPanelEnabledIcon__QLCTf_",
  "rn": "GeneralPanelEvaluateIcon__kK_ueb",
  "MW": "GeneralPanelDisabledIcon__5uparI",
  "SK": "GeneralPanelNameInput__JLMr1y",
  "BF": "GeneralPanelReadOnlyRow__Waf4xP",
};

module.exports = exports;
